import React, { FunctionComponent, ReactElement, useState } from 'react'
import cn from 'classnames'
import s from './Tooltip.module.scss'

interface Props {
    className?: string
    direction?: string
    heading?: ReactElement | string
    delay?: number
}

const Tooltip: FunctionComponent<Props> = ({
    className,
    children,
    direction,
    delay,
    heading
}) => {
    let timeout: NodeJS.Timeout

    const [active, setActive] = useState(false)

    const showTip = () => {
        timeout = setTimeout(() => {
            setActive(true)
        }, delay || 400)
    }

    const hideTip = () => {
        clearInterval(timeout)
        setActive(false)
    }

    return (
        <div className={cn(s['tooltip-wrapper'], 'tooltip', className)}>
            <span
                className={cn(s['tooltip-title'], 'tooltip-title')}
                onMouseEnter={showTip}
                onMouseLeave={hideTip}
            >
                {heading}
            </span>
            {active && (
                <div
                    className={cn(
                        s.tooltip,
                        s[direction || 'top'],
                        'tooltip-content'
                    )}
                >
                    {children}
                </div>
            )}
        </div>
    )
}

export default Tooltip
